const CHARS_TO_REPLACE = [
  [/\+/g, '&#43;'],
  [/-/g, '&#45;'],
];

export function replaceChars(str: string) {
  if (!str) return '';

  CHARS_TO_REPLACE.forEach(([regexp, sign]) => {
    str = str.replace(regexp, sign as string);
  });

  return str;
}
